import Accordion from "./Accordion";

export default {
    init() {
        if (document.querySelector('.section--careers-accordion .accordion')) {
            Array.from(document.querySelectorAll('.section--careers-accordion .accordion'))
                .forEach(el => {
                    el.accordion = new Accordion(el);
                });
        }
    }
}
